import { render, staticRenderFns } from "./SubTest.vue?vue&type=template&id=e4bc5aba&scoped=true&"
import script from "./SubTest.vue?vue&type=script&lang=js&"
export * from "./SubTest.vue?vue&type=script&lang=js&"
import style0 from "./SubTest.vue?vue&type=style&index=0&id=e4bc5aba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4bc5aba",
  null
  
)

export default component.exports